export default "__VITE_ASSET__BIhfHK8z__"